var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered-content-row dark"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-12"},[_c('h2',{staticClass:"title "},[_vm._v(_vm._s(_vm.province))])]),_vm._v(" "),_vm._l((_vm.hotels),function(hotel,index){return [_c('HotelTile',{key:((hotel.id) + "}"),attrs:{"hotel":hotel,"has-offset":index >= 1 && index % 3 == 0}})]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035bbf1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/province-listing.vue
// module id = 22
// module chunks = 0